<template>
  <div class="input-container">
    <label
      for="email"
      class="input__label"
    >E-mail address</label>
    <input
      id="email"
      v-model.lazy="$v.email.$model"
      class="input"
      :class="{'input--error' : ($v.email.$invalid === true && $v.email.$error === true) || (isValidInput === true)}"
      type="text"
      name="email"
      autocomplete="off"
      @input="updateEmail"
    >
    <span
      v-show="($v.email.$invalid === true && $v.email.$error === true) || (isValidInput === true)"
      class="input__error"
    >
      Invalid E-mail
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import { required, email } from 'vuelidate/lib/validators'
axios.defaults.headers.post['apiToken'] = 'wGglfMbWh57xpG890VXSKiB0Obzr3ZY2Ou1kiRlQpuTUnaJbjsiAEvqi6QsgLdfu'
export default {
  props: {
    emailProp: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      email: '',
      isRegistered: false,
      isValidInput: false
    }
  },
  watch: {
    '$v.email.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.email)
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
    },
    email (val) {
      this.updateEmail()
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  mounted () {
    if (this.emailProp) { this.email = this.emailProp }
  },
  methods: {
    updateEmail () {
      this.triggerTouch()
      if (this.$v.email.$invalid !== true && this.$v.email.$error !== true && this.email !== '') {
        this.$emit('input', this.email)
        axios.post('https://' + process.env.VUE_APP_LINK + '/api/check/email', { email: this.email })
          .then((response) => {
            this.$emit('isRegistered', response.data.isRegistered)
            this.isRegistered = response.data.isRegistered
            if (response.data.isRegistered === false) {
              this.isValidEmail(this.email)
            } else {
              this.isValidInput = false
            }
          }).catch((error) => {
            console.log(error)
          })
      }
    },
    triggerTouch () {
      this.$v.$touch()
    },
    isValidEmail (val) {
      if (this.isRegistered === false) {
        return axios.post('https://' + process.env.VUE_APP_LINK + '/api/email/verify', { email: val, verificationLevel: 'unknown' })
          .then((response) => {
            this.$emit('valid', response.data, this.$options._componentTag)
            this.isValidInput = !response.data
          }).catch((ex) => {
            console.log(ex)
            this.$emit('valid', false, this.$options._componentTag)
          })
      }
      return true
    }
  }
}
</script>
